import { render, staticRenderFns } from "./WidgetEditorHeader.vue?vue&type=template&id=23692b66&scoped=true"
import script from "./WidgetEditorHeader.vue?vue&type=script&lang=js"
export * from "./WidgetEditorHeader.vue?vue&type=script&lang=js"
import style0 from "./WidgetEditorHeader.vue?vue&type=style&index=0&id=23692b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23692b66",
  null
  
)

export default component.exports